import * as Yup from 'yup';

export const PHOTO_TYPES = ['image/jpeg', 'image/png'];
export const PHOTO_MAX_BYTES = 3 * 1024 * 1024;

export const baseFields = [
  { name: 'first_name', label: 'First name', type: 'text', autoComplete: 'given-name' },
  { name: 'last_name', label: 'Last name', type: 'text', autoComplete: 'family-name' },
  { name: 'email', label: 'Email', type: 'email', autoComplete: 'email' },
  { name: 'phone', label: 'Phone', type: 'tel', autoComplete: 'tel' },
];

export const genderOptions = [
  { value: 0, title: 'Female' },
  { value: 1, title: 'Male' },
  { value: 2, title: 'None' },
];

const required = 'Required';

export const profileSchema = Yup.object({
  first_name: Yup.string().trim().required(required).min(2, 'Use at least 2 characters.').max(255),
  last_name: Yup.string().trim().required(required).min(2, 'Use at least 2 characters.').max(255),
  email: Yup.string().trim().required(required).email('Enter a valid email.').max(255),
  phone: Yup.string()
    .trim()
    .required(required)
    .min(3, 'Enter a valid phone number.')
    .max(25, 'Enter a valid phone number.'),
  country_id: Yup.number().typeError(required).required(required),
  city_id: Yup.number().typeError(required).required(required),
});

export const passwordSchema = Yup.object({
  current_password: Yup.string().required(required),
  password:Yup.string().required(required).min(6, 'Use at least 6 characters.'),
  password_confirmation: Yup.string()
    .required(required)
    .oneOf([Yup.ref('password')], 'Passwords don\'t match.'),
});

// BE requires the full profile on every update, password-only included.
export const getProfileValues = userInfo => ({
  first_name: userInfo?.first_name ?? '',
  last_name: userInfo?.last_name ?? '',
  email: userInfo?.email ?? '',
  phone: userInfo?.phone ?? '',
  country_id: userInfo?.country_id ?? '',
  city_id: userInfo?.city_id ?? '',
  gender: userInfo?.gender ?? '',
});

export const getPhotoError = file => {
  if (!PHOTO_TYPES.includes(file.type)) return 'Use a JPEG or PNG file.';
  if (file.size > PHOTO_MAX_BYTES) return 'File is larger than 3 MB.';
  return null;
};
